<template>
    <div class="key-data-sup-base-info">
        <div class="title-container">
            <span class="sub-title">退出信息</span>
            <i :class="contentVisible ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" @click="handleCollapse"></i>
        </div>
        <div class="content" v-if="contentVisible">
            <el-row>
                <el-col class="has-bg right-text" :span="3">退出业务类型</el-col>
                <el-col :span="5">{{ formData.quitServiceType }}</el-col>
                <el-col class="has-bg right-text" :span="3">退出类型</el-col>
                <el-col :span="5">{{ formData.quitType }}</el-col>
                <el-col class="has-bg right-text" :span="3">退出原因</el-col>
                <el-col :span="5">{{ formData.quitReason }}</el-col>
            </el-row>
            <el-row>
                <el-col class="has-bg right-text" :span="3">备注</el-col>
                <el-col :span="21">{{ formData.memo }}</el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
import { dictWithUrl } from '@/components/lots/api'
import { getQuitBlackByAuditId } from '../../../../../../api/keyDataDetail.js'

export default {
    props: {
        auditId: {
            type: String,
            default: () => {
                return ''
            }
        }
    },
    data() {
        return {
            contentVisible: true,
            dictData: {},
            formData: {
                quitServiceType: '-',
                quitType: '-',
                quitReason: '-',
                memo: '-',
            },
        };
    },
    methods: {
        loadData() {
            getQuitBlackByAuditId({ auditId: this.auditId }).then(res => {
                if (res && +res.code === 0) {
                    this.setFormData(res.data)
                }
            }).catch(err => {})
        },
        setFormData(data) {
            this.formData.quitServiceType = this.dictData.BID_BUSINESS_TYPE[data.quitServiceType] || '-'
            this.formData.quitType = this.dictData.SU_QUIT_TYPE[data.quitType] || '-'
            this.formData.quitReason = this.dictData.SRM_SU_QUIT_REASON[data.quitReason] || '-'
            this.formData.memo = data.memo || '-'
        },
        handleCollapse() {
            this.contentVisible = !this.contentVisible
        }
    },
    mounted() {
        dictWithUrl('BID_BUSINESS_TYPE,SU_QUIT_TYPE,SRM_SU_QUIT_REASON').then(res => {
            if (res && +res.code === 0) {
                this.dictData = res.data
                this.loadData()
            }
        }).catch(err => {})
    },
};
</script>
<style lang="less">
.key-data-sup-base-info {
    margin-bottom: 20px;
    font-size: 14px;
    color: #000;

    .sub-title {
        display: inline-block;
        font-weight: bold;

        &::before {
            display: inline-block;
            // border-radius: 50%;
            margin-right: 5px;
            width: 5px;
            height: 14px;
            background: #000;
            content: '';
            vertical-align: middle;
        }
    }

    .title-container {
        margin-bottom: 5px;

        i {
            float: right;
            padding-right: 10px;
            font-size: 24px;
            cursor: pointer;
        }
    }

    .content {
        border-top: 1px solid #ddd;
        border-left: 1px solid #ddd;
    }

    .has-bg {
        background: #f5f7fa;
    }

    .right-text {
        text-align: right;
    }

    .el-col {
        padding: 5px;
        border-right: 1px solid #ddd;
        border-bottom: 1px solid #ddd;
        min-height: 30px;
    }

    .wrap-label-row .el-col {
        min-height: 50px;
    }

    .preview-btn {
        padding: 0;
    }
}
</style>